<div [hidden]="!active" class="ph-tabs__pane">
  <ng-content></ng-content>
</div>
